var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5996 4C15.8398 4 16.9608 3.99957 17.8164 4.43555C18.5689 4.81902 19.181 5.43109 19.5645 6.18359C20.0004 7.03924 20 8.16018 20 10.4004V11.5996C20 13.8398 20.0004 14.9608 19.5645 15.8164C19.181 16.5689 18.5689 17.181 17.8164 17.5645C16.9608 18.0004 15.8398 18 13.5996 18H6.41406C6.1489 18 5.89453 18.1055 5.70703 18.293L3.70703 20.293C3.07709 20.9228 2.00012 20.4767 2 19.5859V10.4004C2 8.16018 1.99957 7.03924 2.43555 6.18359C2.81902 5.43109 3.43109 4.81902 4.18359 4.43555C5.03924 3.99957 6.16018 4 8.40039 4H13.5996ZM8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12H8ZM8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10H14C14.5523 10 15 9.55228 15 9C15 8.44772 14.5523 8 14 8H8Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentActive);
export default __webpack_public_path__ + "static/media/CommentActive.7d2d1acbbc4bb53e8493f6e9e7b830b0.svg";
export { ForwardRef as ReactComponent };